const styles = {
  root: {

  },

  pagination: {
    width: 'fit-content',
    margin: '0 auto',
    marginY: 3,
  },

  quoter: {
    height: 257,
    width: '100%',
    border: 1,
    borderColor: 'divider',
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    '& .MuiGrid2-container': {
      border: 'none',
    },
    '& .column ': {
      pl: 0,
      display: 'flex',
      position: 'relative',
      '& .MuiGrid2-root ': {
        float: 'left',
        width: '100%',
        '& .MuiAutocomplete-root': {
          width: '45%',
        },
        ':nth-of-type(2)': {
          '& .MuiAutocomplete-root': {
            position: 'absolute',
            top: { xs: 8, md: 8, lg: '12px' },
            right: 0,
          },
        },
        '& .MuiButton-root ': {
          mt: { xs: 0, md: 0 },
        },
      },
    },
  },
}

export default styles
